import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";

const HouseholdAsset = ({ householdAsset }) => {

    const householdAssetColumns = [
        {
            field: "internalassetid",
            headerName: "Internal Asset ID",
            headerAlign: "center",
            align: "center",
            flex: 200,
            type: "string",
            editable: false,
          },
            {
              field: "householdassessmentid",
              headerName: "Household Assessment ID",
              headerAlign: "center",
              align: "center",
              flex: 200,
              type: "string",
              editable: false,
            },
            {
                field: "internalapplicationid",
                headerName: "Internal Application ID",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "assetvalue",
                headerName: "Asset Value",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "assetcount",
                headerName: "Asset Count",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "assettypeid",
                headerName: "Asset Type ID",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "isValue",
                headerName: "Is Value",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              }
    ];

    return(<>
         <AccordianContainer
          id="accord"
          title="Household Asset"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={(householdAsset !== undefined && householdAsset !== null) ?
              householdAsset.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []}
            columns={householdAssetColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.internalassetid}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
    </>);
}

export default HouseholdAsset;